module.exports = __webpack_public_path__ + "src/client/assets/bank-logos/wells@2x.png";


//////////////////
// WEBPACK FOOTER
// ./src/client/assets/bank-logos/wells@2x.png
// module id = 1198
// module chunks = 0